import { colorPalette } from 'helpers/styledVariables'
import styled from 'styled-components'


export const StyledDashboardChart = styled.div`
	// FOR ALL DIAGRAMS

	.dchart__wrapper{
		display: flex;
		align-items: center;
	}

	.dchart__header{
		padding-bottom: 35px;
		&:after {
			position: absolute;
			content: ' ';
			height: 1px;
			width: 80%;
			top: 76px;
			z-index: 3;
			left: 50%;
			transform: translate(-50%, 0);
			background: linear-gradient(45deg, #f9f9f8, #CDCDCD, #CDCDCD, #f9f9f8);
		}
	}

	.dchart__date_interval{
		border: 1px solid #4A90E2;
		padding: 6px 15px;
		border-radius: 100px;
		font-size: 12px;
		font-weight: 500;
		color: #4A90E2 !important;
		@media(max-width: 465px){
			padding: 2px 7px;
		}
		@media(max-width: 395px){
			padding: 1px 3px;
		}
		&_sales{
			color: #45DB5D !important;
			border-color: #45DB5D;
		}
	}

	.dchart__title{
		font-size: 18px;
		font-weight: 600;
		margin-right: 10px;
	}

	.dchart__total{
		display: flex;
		align-items: center;
		&__label{
			text-transform: capitalize;
			color: #434343;
			font-size: 16px;
			font-weight: 400;
			margin-right: 10px;
		}
		&__value{
			padding: 7px 15px;
			border: 1px solid #4A90E2;
			color: #4A90E2;
			font-size: 18px;
			font-weight: 600;
			border-radius: 100px;
			@media(max-width: 465px){
				padding: 3px 7px;
			}
			@media(max-width: 395px){
				padding: 1px 3px;
			}
		}
		&_sales{
			& .dchart__total__value{
				color: #45DB5D;
				border-color: #45DB5D;
			}
		}
	}

	//ON GRAPHIK HOVER
	& .recharts-tooltip-wrapper>div{
		background-color: white;
		border: 1px solid #CDCDCD;
		box-shadow: none;
	}


	// x AND y AXES
	& .recharts-cartesian-axis-line{
		stroke: #CDCDCD;
	}

	& .recharts-cartesian-axis-tick-line{
		stroke: #CDCDCD;
	}

	@media (max-width: 768px){
		font-size: 10px;
		& .dchart__header{
			& h3.dchart__title{
				font-size: 1.7142857em;
			}
		}
		& .recharts-surface .xAxis text tspan, .recharts-surface .yAxis text tspan{
			font-size: 0.7142857em;
		}
	}

	@media(max-width: 500px){
		font-size: 9px;
	}

	@media(max-width: 465px){
		font-size: 8px;
	}

	@media(max-width: 395px){
		font-size: 7px;
	}

	@media(max-width: 340px){
		font-size: 6px;
	}

	// WE HAVE DIAGRAMS IN BRANCH TAB
	// lineChart, salesLine, barChart, salesBar

	&.lineChart{
		.dchart__header{
			padding-bottom: 20px;
			@media (max-width: 768px){
				padding-bottom: 9px;
			}
			&:after {
				top: 75px;
				@media (max-width: 1200px){
					top: 74px;
				}
				@media (max-width: 768px){
					top: 64px;
				}
			}
		}

		.grad_field0{
			stop:nth-child(1) {
				stop-color: #4A90E2;
			  }
			
			stop:nth-child(2) {
				stop-color: #4A90E2;
			}
		}

		.grad_field1{
			stop:nth-child(1) {
				stop-color: #F2874F;
			  }
			
			stop:nth-child(2) {
				stop-color: #F2874F;
			}
		}

		//ON GRAPHIK HOVER
		& .recharts-tooltip-wrapper>div{
			& div:nth-child(1) span{
				color: #565656;
			}  
			& div:nth-child(2) span{
				color: #4A90E2;
			}
			& div:nth-child(3) span{
				color: #F2874F;
			}
		}
	}

	&.salesLine{
		.dchart__header{
			padding-bottom: 23px;
			&:after {
				top: 67px;

				@media(max-width: 768px){
					top: 55px;
				}

				@media(max-width: 500px){
					top: 53px;
				}

				@media(max-width: 465px){
					top: 52px;
				}

				@media(max-width: 395px){
					top: 49px;
				}

				@media(max-width: 340px){
					top: 48px;
				}
			}
		}

		svg stop:nth-child(1) {
			stop-color: #45DB5D;
		  }
		
		svg stop:nth-child(2) {
			stop-color: #45DB5D;
		}
		
		//ON GRAPHIK HOVER
		& .recharts-tooltip-wrapper>div{
			& div:nth-child(1) span{
				color: #565656;
			}  
			& div:nth-child(2) span{
				color: #45DB5D;
			}
			& div:nth-child(3) span{
				color: #F2874F !important;
			}
		}
	}

	&.barChart, &.salesBar{
		.dchart__header{
			padding-bottom: 19px;
			@media (max-width: 768px){
				padding-bottom: 9px;
				& .dchart__wrapper{
					& h3.dchart__title{
						font-size: 1.7142857em;
						margin-right: 0.7142857em;
					}
					& span.dchart__date_interval{
						font-size: 0.8571428em;
					}
				}
				& .dchart__total{
					& h3.dchart__total__label{
						font-size: 1em;
						margin-right: 0.3571428em;
					}
					& span.dchart__total__value{
						font-size: 1em;
					}
				}
			}
			&:after {
				top: 77px;
				@media(max-width: 768px){
                    top: 57px;
                }

                @media(max-width: 500px){
                    top: 56px;
                }

                @media(max-width: 465px){
                    top: 47px;
                }

                @media(max-width: 395px){
                    top: 44px;
                }

                @media(max-width: 340px){
                    top: 41px;
                }
			}
		}

		@media(max-width: 768px){
			& .recharts-surface .xAxis text tspan{
				font-size: 1em;
			}
		}
	}

	&.barChart{
		// BAR CHART

		svg stop:nth-child(1) {
			stop-color: rgba(74, 144, 226, 1);
		  }
		
		svg stop:nth-child(2) {
			stop-color: rgba(74, 144, 226, 1);
		}

		& .recharts-rectangle{
			stroke: #4A90E2;
		}

		//ON GRAPHIK HOVER
		& .recharts-tooltip-wrapper>div{
			& span{
				color: #4A90E2;
			}
		}
	}

	&.salesBar{
		// BAR CHART

		svg stop:nth-child(1) {
			stop-color: #45DB5D;
		  }
		
		svg stop:nth-child(2) {
			stop-color: rgba(69, 219, 93, 1);
		}

		& .recharts-rectangle{
			stroke: #45DB5D;
		}

		//ON GRAPHIK HOVER
		& .recharts-tooltip-wrapper>div{
			& span{
				color: #45DB5D;
			}
		}
	}

	// DIAGRAMS IN TOP COMPINATION

	&.topCombinationChart>div{
		@media (max-width: 768px){
			padding: 10px 10px 10px 0;
		}
		& .dchart__header{
			align-items: start;
			padding-bottom: 0px;
			margin-bottom: 20px;
			height: 28px;
			margin-bottom: 17px;
			@media (max-width: 1200px){
				margin-bottom: 2px;
			}
			@media (max-width: 768px){
				height: 38px;
				margin-bottom: 6px;
			}
			@media (max-width: 493px){
				height: 33px;
				margin-bottom: 8px;
			}
			@media (max-width: 375px){
				height: 26px;
				margin-bottom: 3px;
			}
			&:after {
				top: 58px;
				@media (max-width: 493px){
					top: 53px;
				}
				@media (max-width: 375px){
					top: 46px;
				}
			}
			& .dchart__title{
				@media (max-width: 768px){
					display: flex;
					width: 100%;
					flex-direction: column;
					& .title_option{
						font-size: 18px !important;
					}
					& .title_where{
						font-size: 14px;
						font-weight: 400;
					}
				}
				@media (max-width: 565px){
					& .title_option{
						font-size: 17px !important;
					}
					& .title_where{
						font-size: 13px;
					}
				}
				@media (max-width: 529px){
					& .title_option{
						font-size: 16px !important;
					}
					& .title_where{
						font-size: 12px;
					}
				}

				@media (max-width: 493px){
					& .title_option{
						font-size: 14px !important;
					}
					& .title_where{
						font-size: 11px;
					}
				}

				@media (max-width: 451px){
					& .title_option{
						font-size: 13px !important;
					}
					& .title_where{
						font-size: 10px;
					}
				}

				@media (max-width: 415px){
					& .title_option{
						font-size: 12px !important;
					}
					& .title_where{
						font-size: 9px;
					}
				}

				@media (max-width: 378px){
					& .title_option{
						font-size: 11px !important;
					}
					& .title_where{
						font-size: 8px;
					}
				}
				
				@media (max-width: 340px){
					& .title_option{
						font-size: 9px !important;
					}
					& .title_where{
						font-size: 7px;
					}
				}

			}

			// calendar
			&>div{
				margin-right: -10px;
				margin-top: -10px;

				@media (max-width: 768px){
					margin-right: 0px;
					margin-top: 0px;
				}

				@media (max-width: 493px){
					& .top_combinations_dateInterval{
						height: 33px;
					}
				}

				@media (max-width: 451px){
					& .top_combinations_dateInterval{
						height: 31px;
					}
				}

				@media (max-width: 378px){
					& .top_combinations_dateInterval{
						height: 26px;
					}
				}

				@media (max-width: 340px){
					& .top_combinations_dateInterval{
						height: 23px;
					}
				}


				& .top_combinations_dateInterval span:first-child .formated_date{
					@media (max-width: 493px){
						font-size: 12px;
					}
					@media (max-width: 451px){
						font-size: 11px;
					}
					@media (max-width: 415px){
						font-size: 10px;
					}
					@media (max-width: 378px){
						font-size: 9px;
					}
					@media (max-width: 340px){
						font-size: 8px;
					}
				}
			}
		}


		// diagramma
		& .dx-visibility-change-handler{
			
			& .dxc-series-group .dxc-series .dxc-markers{
				& path{
					stroke: white;
					stroke-width: 1;
				}
			}
			& .dxc-labels-group .dxc-labels{
				& g g {

					& rect{
						fill: none !important;
					}

					& text{
					}
				}

				// titles color

				& g:nth-child(1) g text{
					fill: ${colorPalette[0]} !important;
				}

				& g:nth-child(2) g text{
					fill: ${colorPalette[1]} !important;
				}

				& g:nth-child(3) g text{
					fill: ${colorPalette[2]} !important;
				}

				& g:nth-child(4) g text{
					fill: ${colorPalette[3]} !important;
				}

				& g:nth-child(5) g text{
					fill: ${colorPalette[4]} !important;
				}

				& g:nth-child(6) g text{
					fill: ${colorPalette[5]} !important;
				}

				& g:nth-child(7) g text{
					fill: ${colorPalette[6]} !important;
				}

				& g:nth-child(8) g text{
					fill: ${colorPalette[7]} !important;
				}

				& g:nth-child(9) g text{
					fill: ${colorPalette[8]} !important;
				}

				& g:nth-child(10) g text{
					fill: ${colorPalette[9]} !important;
				}

				& g:nth-child(11) g text{
					fill: ${colorPalette[10]} !important;
				}

				& g:nth-child(12) g text{
					fill: ${colorPalette[11]} !important;
				}

				& g:nth-child(13) g text{
					fill: ${colorPalette[12]} !important;
				}

				& g:nth-child(14) g text{
					fill: ${colorPalette[13]} !important;
				}

				& g:nth-child(16) g text{
					fill: ${colorPalette[14]} !important;
				}

				& g:nth-child(17) g text{
					fill: ${colorPalette[15]} !important;
				}

				& g:nth-child(18) g text{
					fill: ${colorPalette[16]} !important;
				}

				& g path{
					stroke: #CDCDCD !important;
				}
			}
			& .dxc-legend{
				& .dxc-item{
					&>g{

					}
				}
				& .dxl-marker rect{
					width: 17px;
					height: 17px;
					@media (max-width: 768px){
						width: 14px;
						height: 14px;
					}
					@media (max-width: 352px){
						width: 12px;
						height: 12px;
					}
				}
			}
		}
	}
`
